module.exports = __webpack_public_path__ + "img/about_9.b48c2ada.png";